const zIndexMultiplier = 100000;

const zIndex = {
  mobileStepper: zIndexMultiplier + 1,
  fab: zIndexMultiplier + 50,
  speedDial: zIndexMultiplier + 50,
  appBar: zIndexMultiplier + 100,
  drawer: zIndexMultiplier + 200,
  modal: zIndexMultiplier + 300,
  snackbar: zIndexMultiplier + 400,
  tooltip: zIndexMultiplier + 500,
};

export default zIndex;
